import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';

function* changeLangSagaFunc() {
  yield put({ type: 'changeLangReducer'});

}
function* changeModeSagaFunc() {
  yield put({ type: 'changeModeReducer'});

}
function* changeCookieSagaFunc() {
  yield put({ type: 'changeCookieReducer'});

}

function* mySaga() {
  yield takeEvery('changeLangAction', changeLangSagaFunc);
  yield takeEvery('changeModeAction', changeModeSagaFunc);
  yield takeEvery('changeCookieAction', changeCookieSagaFunc);
}

export default mySaga;